const UTILS = require("../libs/utils.js");
var vA752 = [];
module.exports = [{
  name: "Build Block",
  color: "#5e432b",
  breakSnd: "break_wood",
  places: "all",
  buildSnap: function (p16612, p16613, p16614, p16615, p16616, p16617, p16618) {
    if (p16618 == 0) {
      if (p16616 == "Top") {
        return [p16617.x, p16617.y + p16617.height, p16617.z, p16615];
      }
      if (p16616 == "Bottom") {
        return [p16617.x, p16617.y - p16617.height * 3, p16617.z, p16615];
      }
      if (p16616 == "Left") {
        return [p16617.x - p16617.width * 2, p16617.y - p16617.height, p16617.z, p16615];
      }
      if (p16616 == "Right") {
        return [p16617.x + p16617.width * 2, p16617.y - p16617.height, p16617.z, p16615];
      }
      if (p16616 == "Front") {
        return [p16617.x, p16617.y - p16617.height, p16617.z - p16617.length * 2, p16615];
      }
      if (p16616 == "Back") {
        return [p16617.x, p16617.y - p16617.height, p16617.z + p16617.length * 2, p16615];
      }
    }
    if (p16618 == 1) {
      if (p16616 == "Top") {
        return [p16617.x, p16617.y + p16617.height, p16617.z, p16615];
      } else if (p16616 == "Bottom") {
        return [p16617.x, p16617.y - p16617.height, p16617.z, p16615];
      } else {
        return [p16617.x, p16613, p16617.z, p16615];
      }
    } else {
      return [p16612, p16613, p16614, false];
    }
  },
  snapFunc: function (p16619, p16620, p16621, p16622, p16623, p16624, p16625, p16626) {
    if (p16625 == 0) {
      return UTILS.lineInRect(p16619, p16620, p16621, p16622, p16623, p16624, p16626.x - p16626.width, p16626.z - p16626.length, p16626.y - p16626.height, p16626.x + p16626.width, p16626.z + p16626.length, p16626.y + p16626.height) || UTILS.lineInRect(p16619, p16620, p16621, p16622, p16623, p16624, p16626.x - p16626.width * 2, p16626.z - p16626.length * 0.98, p16626.y - p16626.height + 0.0001, p16626.x + p16626.width * 2, p16626.z + p16626.length * 0.98, p16626.y + p16626.height - 0.0001) || UTILS.lineInRect(p16619, p16620, p16621, p16622, p16623, p16624, p16626.x - p16626.width * 0.98, p16626.z - p16626.length * 2, p16626.y - p16626.height + 0.0001, p16626.x + p16626.width * 0.98, p16626.z + p16626.length * 2, p16626.y + p16626.height - 0.0001) || UTILS.lineInRect(p16619, p16620, p16621, p16622, p16623, p16624, p16626.x - p16626.width * 0.98, p16626.z - p16626.length * 0.98, p16626.y - p16626.height * 1.5, p16626.x + p16626.width * 0.98, p16626.z + p16626.length * 0.98, p16626.y + p16626.height * 1.5);
    } else {
      return null;
    }
  },
  icon: 0,
  cost: 10,
  health: 300,
  w: 10,
  h: 10,
  l: 10
}, {
  name: "Platform",
  color: "#5e432b",
  breakSnd: "break_wood",
  src: "grain_0",
  places: "all",
  buildSnap: function (p16627, p16628, p16629, p16630, p16631, p16632, p16633) {
    if (p16633 == 0) {
      if (p16631 == "Top" || p16631 == "Bottom") {
        var vLN58 = 5;
        var v13464 = (Math.abs(p16632.x - p16632.width - p16627) / (p16632.width * 2)).roundToNearest(1 / 3);
        var v13465 = p16632.x - p16632.width - vLN58 + p16632.width * 2 * v13464;
        var v13466 = p16628 - (p16631 == "Bottom" ? 10 : 0);
        var v13467 = (Math.abs(p16632.z - p16632.length - p16629) / (p16632.length * 2)).roundToNearest(1 / 3);
        var v13468 = p16632.z - p16632.length - vLN58 + p16632.length * 2 * v13467;
        return [v13465, v13466, v13468, p16630];
      }
      return [p16627, p16628, p16629, false];
    }
    if (p16633 == 1) {
      if (p16631 == "Top") {
        return [p16632.x, p16632.y + p16632.height, p16632.z, p16630];
      }
      if (p16631 == "Bottom") {
        return [p16632.x, p16632.y - p16632.height * 3, p16632.z, p16630];
      }
      if (p16631 == "Left") {
        return [p16632.x - p16632.width * 2, p16632.y - p16632.height, p16632.z, p16630];
      }
      if (p16631 == "Right") {
        return [p16632.x + p16632.width * 2, p16632.y - p16632.height, p16632.z, p16630];
      }
      if (p16631 == "Front") {
        return [p16632.x, p16632.y - p16632.height, p16632.z - p16632.length * 2, p16630];
      }
      if (p16631 == "Back") {
        return [p16632.x, p16632.y - p16632.height, p16632.z + p16632.length * 2, p16630];
      }
    } else {
      if (p16633 == 2) {
        var v13471 = UTILS.findNearest(p16627, p16629, [p16632.x - p16632.width, p16632.z, p16632.x + p16632.width, p16632.z, p16632.x, p16632.z - p16632.length, p16632.x, p16632.z + p16632.length]);
        var v13470 = v13471[2] == 0 || v13471[2] == 2;
        return [v13471[0], p16632.y, v13471[1], p16630, v13470];
      }
      if (p16633 == 3) {
        if (p16628 >= p16632.y) {
          var v13471 = UTILS.findNearest(p16627, p16629, [p16632.x - p16632.width, p16632.z, p16632.x + p16632.width, p16632.z, p16632.x, p16632.z - p16632.length, p16632.x, p16632.z + p16632.length]);
          return [p16632.x, p16632.y + p16632.height, p16632.z, p16630];
        }
        return [p16627, p16628, p16629, false];
      }
    }
    return [p16627, p16628, p16629, p16630];
  },
  snapFunc: function (p16634, p16635, p16636, p16637, p16638, p16639, p16640, p16641) {
    if (p16640 == 1) {
      return UTILS.lineInRect(p16634, p16635, p16636, p16637, p16638, p16639, p16641.x - p16641.width, p16641.z - p16641.length, p16641.y - p16641.height, p16641.x + p16641.width, p16641.z + p16641.length, p16641.y + p16641.height) || UTILS.lineInRect(p16634, p16635, p16636, p16637, p16638, p16639, p16641.x - p16641.width * 2, p16641.z - p16641.length * 0.98, p16641.y - p16641.height + 0.0001, p16641.x + p16641.width * 2, p16641.z + p16641.length * 0.98, p16641.y + p16641.height - 0.0001) || UTILS.lineInRect(p16634, p16635, p16636, p16637, p16638, p16639, p16641.x - p16641.width * 0.98, p16641.z - p16641.length * 2, p16641.y - p16641.height + 0.0001, p16641.x + p16641.width * 0.98, p16641.z + p16641.length * 2, p16641.y + p16641.height - 0.0001);
    }
    if (p16640 == 2) {
      vA752.length = 0;
      vA752.push(UTILS.lineInRect(p16634, p16635, p16636, p16637, p16638, p16639, p16641.x - p16641.width, p16641.z - p16641.length, p16641.y - p16641.height, p16641.x - p16641.width, p16641.z + p16641.length, p16641.y + 30));
      vA752.push(UTILS.lineInRect(p16634, p16635, p16636, p16637, p16638, p16639, p16641.x + p16641.width, p16641.z - p16641.length, p16641.y - p16641.height, p16641.x + p16641.width, p16641.z + p16641.length, p16641.y + 30));
      vA752.push(UTILS.lineInRect(p16634, p16635, p16636, p16637, p16638, p16639, p16641.x - p16641.width, p16641.z - p16641.length, p16641.y - p16641.height, p16641.x + p16641.width, p16641.z - p16641.length, p16641.y + 30));
      vA752.push(UTILS.lineInRect(p16634, p16635, p16636, p16637, p16638, p16639, p16641.x - p16641.width, p16641.z + p16641.length, p16641.y - p16641.height, p16641.x + p16641.width, p16641.z + p16641.length, p16641.y + 30));
      vA752.push(UTILS.lineInRect(p16634, p16635, p16636, p16637, p16638, p16639, p16641.x - p16641.width, p16641.z - p16641.length, p16641.y - p16641.height, p16641.x + p16641.width, p16641.z + p16641.length, p16641.y + p16641.height));
      var v13472 = null;
      for (var vLN02433 = 0; vLN02433 < vA752.length; ++vLN02433) {
        if (vA752[vLN02433] && (v13472 == null || vA752[vLN02433] < v13472)) {
          v13472 = vA752[vLN02433];
        }
      }
      return v13472;
    }
    return null;
  },
  icon: 3,
  cost: 50,
  health: 500,
  w: 30,
  h: 2,
  l: 30
}, {
  name: "Wall",
  color: "#5e432b",
  breakSnd: "break_wood",
  src: "grain_0",
  places: "objs",
  rotFacing: true,
  rotDir: true,
  snapFunc: function (p16642, p16643, p16644, p16645, p16646, p16647, p16648, p16649) {
    if (p16648 == 2) {
      vA752.length = 0;
      var v13473 = p16649.width > p16649.length;
      if (v13473) {
        vA752.push(UTILS.lineInRect(p16642, p16643, p16644, p16645, p16646, p16647, p16649.x - p16649.width * 2, p16649.z - p16649.length * 0.98, p16649.y - p16649.height * 0.98, p16649.x + p16649.width * 2, p16649.z + p16649.length * 0.98, p16649.y + p16649.height * 0.98));
        vA752.push(UTILS.lineInRect(p16642, p16643, p16644, p16645, p16646, p16647, p16649.x + p16649.width, p16649.z - p16649.width, p16649.y - p16649.height * 0.98, p16649.x + p16649.width, p16649.z + p16649.width, p16649.y + p16649.height * 0.98));
        vA752.push(UTILS.lineInRect(p16642, p16643, p16644, p16645, p16646, p16647, p16649.x - p16649.width, p16649.z - p16649.width, p16649.y - p16649.height * 0.98, p16649.x - p16649.width, p16649.z + p16649.width, p16649.y + p16649.height * 0.98));
      } else {
        vA752.push(UTILS.lineInRect(p16642, p16643, p16644, p16645, p16646, p16647, p16649.x - p16649.width * 0.98, p16649.z - p16649.length * 2, p16649.y - p16649.height * 0.98, p16649.x + p16649.width * 0.98, p16649.z + p16649.length * 2, p16649.y + p16649.height * 0.98));
        vA752.push(UTILS.lineInRect(p16642, p16643, p16644, p16645, p16646, p16647, p16649.x - p16649.length, p16649.z - p16649.length, p16649.y - p16649.height * 0.98, p16649.x + p16649.length, p16649.z - p16649.length, p16649.y + p16649.height * 0.98));
        vA752.push(UTILS.lineInRect(p16642, p16643, p16644, p16645, p16646, p16647, p16649.x - p16649.length, p16649.z + p16649.length, p16649.y - p16649.height * 0.98, p16649.x + p16649.length, p16649.z + p16649.length, p16649.y + p16649.height * 0.98));
      }
      vA752.push(UTILS.lineInRect(p16642, p16643, p16644, p16645, p16646, p16647, p16649.x - p16649.width, p16649.z - p16649.length, p16649.y - p16649.height, p16649.x + p16649.width, p16649.z + p16649.length, p16649.y + p16649.height));
      var v13474 = null;
      for (var vLN02434 = 0; vLN02434 < vA752.length; ++vLN02434) {
        if (vA752[vLN02434] && (v13474 == null || vA752[vLN02434] < v13474)) {
          v13474 = vA752[vLN02434];
        }
      }
      return v13474;
    }
    return null;
  },
  buildSnap: function (p16650, p16651, p16652, p16653, p16654, p16655, p16656) {
    if (p16656 == 2) {
      var vP166502 = p16650;
      var vP166522 = p16652;
      var v13475 = p16655.width > p16655.length;
      var v13476 = false;
      if (v13475) {
        if (p16652 > p16655.z + p16655.length) {
          vP166502 = p16650 > p16655.x ? p16655.x + p16655.width : p16655.x - p16655.width;
          vP166522 = p16655.z + p16655.width;
          v13476 = true;
        } else if (p16652 < p16655.z - p16655.length) {
          vP166502 = p16650 > p16655.x ? p16655.x + p16655.width : p16655.x - p16655.width;
          vP166522 = p16655.z - p16655.width;
          v13476 = true;
        } else if (p16650 > p16655.x + p16655.width) {
          vP166502 = p16655.x + p16655.width * 2;
          vP166522 = p16655.z;
        } else if (p16650 < p16655.x - p16655.width) {
          vP166502 = p16655.x - p16655.width * 2;
          vP166522 = p16655.z;
        } else {
          return [p16650, p16651, p16652, false];
        }
      } else if (p16650 > p16655.x + p16655.width) {
        vP166522 = p16652 > p16655.z ? p16655.z + p16655.length : p16655.z - p16655.length;
        vP166502 = p16655.x + p16655.length;
      } else if (p16650 < p16655.x - p16655.width) {
        vP166522 = p16652 > p16655.z ? p16655.z + p16655.length : p16655.z - p16655.length;
        vP166502 = p16655.x - p16655.length;
      } else if (p16652 > p16655.z + p16655.length) {
        vP166522 = p16655.z + p16655.length * 2;
        vP166502 = p16655.x;
        v13476 = true;
      } else if (p16652 < p16655.z - p16655.length) {
        vP166522 = p16655.z - p16655.length * 2;
        vP166502 = p16655.x;
        v13476 = true;
      } else {
        return [p16650, p16651, p16652, false];
      }
      return [vP166502, p16655.y - p16655.height, vP166522, p16653, v13476];
    }
    if (p16656 == 3) {
      var vP166502 = p16650;
      var vP166522 = p16652;
      if (p16654 == "Right" && p16655.length > p16655.width) {
        vP166502 = p16655.x + 15;
        vP166522 = p16655.z;
      } else if (p16654 == "Left" && p16655.length > p16655.width) {
        vP166502 = p16655.x - 15;
        vP166522 = p16655.z;
      } else if (p16654 == "Front" && p16655.width > p16655.length) {
        vP166502 = p16655.x;
        vP166522 = p16655.z - 15;
      } else if (p16654 == "Back" && p16655.width > p16655.length) {
        vP166502 = p16655.x;
        vP166522 = p16655.z + 15;
      } else {
        return [p16650, p16651, p16652, false];
      }
      return [vP166502, p16655.y + 1 - p16655.height, vP166522, p16653];
    }
    return [p16650, p16651, p16652, false];
  },
  icon: 1,
  cost: 50,
  health: 500,
  w: 30,
  h: 30,
  l: 2
}, {
  name: "Stairs",
  color: "#473220",
  breakSnd: "break_wood",
  places: "objs",
  src: "grain_0",
  rotDir: true,
  custMod: function (p16657, p16658, p16659, p16660, p16661, p16662, p16663, p16664, p16665) {
    return p16657.addRamp(p16658, p16659, p16660, p16661, p16663, p16662, p16664, {
      src: this.src || "grain_0",
      buildInd: 3,
      uido: p16665,
      shaderBased: true,
      colr: this.color,
      breakSnd: this.breakSnd,
      model: this.model,
      health: this.health,
      dynamic: true
    });
  },
  buildSnap: function (p16666, p16667, p16668) {
    return [p16666, p16667, p16668, false];
  },
  icon: 4,
  cost: 25,
  health: 150,
  w: 30,
  h: 30,
  l: 30
}];